// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.vgt-global-search__input {\n  padding-left: 0;\n  -webkit-box-flex: unset;\n      -ms-flex-positive: unset;\n          flex-grow: unset;\n}\n", ""]);
// Exports
module.exports = exports;
